import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppStateContext } from '@profile-ui-mono/utilities/context';

const useEditCardTileValue = () => {
  const navigate = useNavigate();
  const context = useContext(AppStateContext);
  const { open, setSelectedPanel, opened } = context.sidePanel;

  const editCardTileValue = ({ panel, route }) => {
    if (!opened) {
      open();
      setSelectedPanel(panel);
      navigate(`${route}/${panel}`);
    }
  };

  return editCardTileValue;
};

export default useEditCardTileValue;
